import { render, staticRenderFns } from "./NotifyReturn.vue?vue&type=template&id=16a10027&scoped=true"
import script from "./NotifyReturn.vue?vue&type=script&lang=js"
export * from "./NotifyReturn.vue?vue&type=script&lang=js"
import style0 from "./NotifyReturn.vue?vue&type=style&index=0&id=16a10027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a10027",
  null
  
)

export default component.exports